// Android keyboard-aware focus helper for text and OTP inputs.

export function scrollFocusedInputIntoView(target: HTMLElement) {
  if (typeof window === 'undefined') return;
  if (!/Android/i.test(window.navigator.userAgent)) return;
  // Vaul drawers handle Android keyboard avoidance themselves; our scroll
  // races their drawer repositioning and causes the input to jump or hide.
  if (target.closest('[data-slot="drawer-content"]')) return;

  window.setTimeout(() => {
    target.scrollIntoView({
      block: 'center',
      inline: 'nearest',
      behavior: 'smooth',
    });
  }, 250);
}
